import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const HeadingWithSubheading = ({ heading, subheading, optionalLeft, optionalRight }) => {

    return (
        <div style={styles.container} className="pb-0 pt-0 mt-0">
            <Row className="align-items-center">
                {/* Header and Subheader */}
                <Col className="text-center">
                    <h2 style={styles.heading}>{heading}</h2>
                    <h3 style={styles.subheading}>{optionalLeft} {subheading} {optionalRight}</h3>
                    
                </Col>
            </Row>
        </div>
    );
};

const styles = {
    container: {
        textAlign: 'center',
        padding: '5px',
    },
    heading: {
        fontSize: '1.5rem',
        margin: '5px 0',
    },
    subheading: {
        fontSize: '1rem',
        color: '#555',
    },
};

export default HeadingWithSubheading;
